// simple logger for the browser
const IS_DEV = process.env.NODE_ENV === 'development';

const timers = new Map<string, number>();
/**
 * @description simple logger for the browser,
 * this is by no means exhaustive and can undergo multiple refinements depending on level of surfacing
 * we could want
 */
const logger = {
  disabled: !IS_DEV,
  info(...args: unknown[]) {
    if (!this.disabled) {
      // eslint-disable-next-line no-console
      console.log('%c[info]', 'color: blue;', ...args);
    }
  },
  warn(...args: unknown[]) {
    if (!this.disabled) {
      // eslint-disable-next-line no-console
      console.warn('%c[warn]', 'color: orange;', ...args);
    }
  },
  error(...args: unknown[]) {
    if (!this.disabled) {
      // eslint-disable-next-line no-console
      console.error('%c[error]', 'color: red; font-weight: bold;', ...args);
    }
  },
  // Performance timing
  time(label: string) {
    if (!this.disabled) {
      timers.set(label, performance.now());
      // eslint-disable-next-line no-console
      console.time(label);
    }
  },
  timeEnd(label: string) {
    if (!this.disabled) {
      const startTime = timers.get(label);
      if (startTime !== undefined) {
        const duration = performance.now() - startTime;
        // eslint-disable-next-line no-console
        console.timeEnd(label);
        // eslint-disable-next-line no-console
        console.log(`%c⏱ ${label}: ${duration.toFixed(2)}ms`, 'color: purple;');
        timers.delete(label);
      } else {
        // eslint-disable-next-line no-console
        console.timeEnd(label);
      }
    }
  },
};

export default logger;
